module.exports = __webpack_public_path__ + "img/ruiyan_05.ab01bac1.jpg";